import Stack from './Stack';

export default class RedoStack extends Stack {
}
